export default __webpack_public_path__ + "static/media/eIcon7.e9e3806c.svg";